export default {
  logout: {
    confirm: {
      title: 'خروج از حساب',
      message: 'از حساب کاربری خود خارج میشوید؟'
    },
    success: 'با موفقیت خارج شدید',
    fail: 'مشکلی در خارج شدن از حساب کاربری رخ داد، مجددا تلاش کنید'
  },
  pageNotFound: 'صفحه مورد نظر یافت نشد!',
  anErrorOccurred: 'مشکلی پیش آمده!',
  register: {
    terms: 'شرایط و قوانین و حریم خصوصی را تایید کنید',
    success: 'ثبت نام با موفقیت انجام شد'
  },
  passwordResetSuccessfully: 'رمز عبور با موفقیت بازنشانی شد',
  profileInformationUpdatedSuccessfully:
    'اطلاعات حساب کاربری با موفقیت بروزرسانی شد',
  legalInfoUpdatedSuccessfully: 'اطلاعات حقوقی با موفقیت بروزرسانی شد',
  passwordChangedSuccessfully: 'رمز عبور با موفقیت تغییر کرد',
  passwordCreatedSuccessfully: 'رمز عبور با موفقیت ساخته شد',
  delete: {
    title: 'حذف {title}',
    message: 'آیا از حذف این {title} اطمینان دارید؟',
    success: '{title} با موفقیت حذف شد'
  },
  create: '{title} با موفقیت ایجاد شد',
  submit: '{title} با موفقیت ثبت شد',
  _edit: '{title} با موفقیت ویرایش شد',
  registerOrder: {
    error: {
      gettingCompanyInfo:
        'مشکلی در دریافت اطلاعات باربری انتخابی به وجود آمده! لطفا مجددا تلاش کنید'
    }
  },
  errorInSearchingAddress: 'جستجوی آدرس با مشکل مواجه شد!',
  map: {
    error: {
      extractAddress: 'استخراج آدرس امکان‌پذیر نسیت! مجددا تلاش کنید',
      locationPermissionDenied: 'باربانت اجازه دسترسی به موقعیت شما را ندارد',
      extractLocation: 'امکان دریافت موقعیت وجود ندارد'
    }
  },
  serverOffline: 'عدم ارتباط با سرور!',
  pleaseTryAgain: 'لطفا مجددا تلاش کنید',
  thisPointCantBeSelected: 'این نقطه قابل انتخاب نمی باشد',
  cancelTemporaryOrder: {
    title: 'لغو درخواست',
    message: 'آیا از لغو درخواست اطمینان دارید؟',
    success: 'درخواست با موفقیت لغو شد'
  },
  orderAutoCancel:
    'متاسفانه هیچ راننده ای درخواست شما را نپذیرفت! لطفا مجددا درخواست خود را ثبت کنید.',
  orderCanceledByDriver:
    'درخواست شما توسط راننده لغو شد! درخواست شما برای دیگر رانندگان ارسال شد.',
  orderCanceledByAdmin:
    'درخواست شما توسط راهبر سیستم لغو شد! لطفا مجددا درخواست خود را ثبت کنید.',
  mobileConfirmedSuccessfully: 'موبایل با موفقیت تایید شد',
  emailConfirmedSuccessfully: 'ایمیل با موفقیت تایید شد',
  loadDischargedSuccessfully: 'سفارش با موفقیت تخلیه شد',
  originAndDestinationShouldDiffrent: 'مبدا و مقصد نباید یکسان باشند!'
}
